import { ArtStyleShowcaseData } from './type'

export const artStyleShowcaseData: ArtStyleShowcaseData = {
  eyebrow: 'Pick Your Look',
  headline: 'One photo.',
  headlineAccent: 'Any art style you love.',
  subtitle: 'Upload your child\'s photo, then tap a style below to see them reimagined — from dreamy watercolors to bold 3D characters. Every page of their story will be illustrated in the look you pick.',
  ctaText: 'Start your story',
  ctaLink: '/shop',
  originalImageUrl: '/images/artstyles/0.png',
  originalImageAlt: 'Original photo of a child before personalisation',
  originalLabel: 'Photo',
  styleLabel: 'Art style',
  styles: [
    {
      id: '3d-stylized',
      name: '3D stylized',
      imageUrl: '/images/artstyles/1.png',
      imageAlt: 'A 3D stylized illustration of the child',
    },
    {
      id: 'ink-and-wash',
      name: 'Ink and wash',
      imageUrl: '/images/artstyles/2.png',
      imageAlt: 'An ink and wash illustration of the child',
    },
    {
      id: 'dreamy-watercolor',
      name: 'Dreamy watercolor',
      imageUrl: '/images/artstyles/3.png',
      imageAlt: 'A dreamy watercolor illustration of the child',
    },
    {
      id: 'felt-and-fabric',
      name: 'Felt and Fabric',
      imageUrl: '/images/artstyles/4.png',
      imageAlt: 'A felt and fabric illustration of the child',
    },
    {
      id: 'retro-cartoon',
      name: 'Retro cartoon',
      imageUrl: '/images/artstyles/5.png',
      imageAlt: 'A retro cartoon illustration of the child',
    },
    {
      id: 'textured-paint',
      name: 'Textured paint',
      imageUrl: '/images/artstyles/6.png',
      imageAlt: 'A textured paint illustration of the child',
    },
    {
      id: 'soft-watercolor',
      name: 'Soft watercolor',
      imageUrl: '/images/artstyles/7.png',
      imageAlt: 'A soft watercolor illustration of the child',
    },
  ],
}
